import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControlPipe } from "@bequeathed/ngx-utils";
import { BaseInputControl } from '../base-input-control/base-input-control.component';
import { KeyValuePipe, NgClass } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";

/**
 * Interview form control to display a numeric-only control
 *
 * @author Dan Bennett (dbennett)
 */
@Component({
    selector: 'number-control',
    templateUrl: '../text-control/text-control.component.html',
    styleUrls: [
        '../base-input-control/base-input-control.component.sass',
        '../../base-form/base-form.component.sass'
    ],
    imports: [
        // Angular
        NgClass,
        ReactiveFormsModule,
        // Bequeathed
        FormControlPipe,
        KeyValuePipe
    ],
    standalone: true,
    encapsulation: ViewEncapsulation.None
})
export class NumberControl extends BaseInputControl implements OnInit {

    constructor() {
        super();
        this.inputType = 'number';
    }

    override ngOnInit(): void {
        this.determineValidators();
        super.ngOnInit();

        if (this.editingResponse) {
            this.setPreviousResponse()
        }
    }
}
